import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CheckboxCell from "../../../common/interactive/CheckboxCell";
import { caseActions } from "../../../../store/case";
import { notificationActions } from "../../../../store/notifications";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { shouldShowFieldUpdateLoader } from "../../../../lib/systemData";

import classes from './LiabilityNoItems.module.css'
import GlobalTooltip from "../../../common/GlobalTooltip";

export default function LiabilityNoItems({permissionType}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const caseData = activeCase?.case ?? {}

    const [savingByField, setSavingByField] = useState({})
    const seqByFieldRef = useRef(new Map())

    const showApiLoader = shouldShowFieldUpdateLoader()

    const updatehandler = async (value) => {
        if (!activeCase?.case?.id) {
            return
        }

        const caseId = activeCase.case.id
        const field = value?.identifier?.field
        if (!field) {
            return
        }

        const nextSeq = (seqByFieldRef.current.get(field) ?? 0) + 1
        seqByFieldRef.current.set(field, nextSeq)

        setSavingByField(prev => ({ ...prev, [field]: true }))
        
        const body = {
            type: value.identifier.type,
            fields: {
                [value.identifier.field] : value.data.value
            }
        }
       
        let update
        try {
            update = await caseQuickUpdate(userToken, caseId, body, null, null, {
                staleGuardKey: `${caseId}:case:${field}`,
                staleGuardSequence: nextSeq,
            })
        } finally {
            // Only clear if this is still the latest request for that field.
            if ((seqByFieldRef.current.get(field) ?? 0) === nextSeq) {
                setSavingByField(prev => ({ ...prev, [field]: false }))
            }
        }

        if (update?.staleResponse) {
            return
        }

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
            
        } else {
            const dispatchObj = {
                folder: value.identifier.folder,
                item: {
                    fields: [
                        {
                            field: value.identifier.field,
                            value: value.data.value
                        },
                    ]            
                }
            }
       
            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
            }, 0)
        }         
    }


    return <div className={classes.container}>
        <p>Liability Flags</p>
        <CheckboxCell label={'Comercial Policy'} checked={caseData.liability_is_commercial_policy} direction={'reverse'} action={updatehandler} identifier={{type: 'case', field: 'liability_is_commercial_policy', type_id: null, folder: 'case', permissionType: permissionType}} apiDisabled={Boolean(savingByField.liability_is_commercial_policy)} showApiLoader={showApiLoader}/>
        <CheckboxCell conditionalCheck={true} label={'DUI'} checked={caseData.liability_is_dui} direction={'reverse'} action={updatehandler} identifier={{type: 'case', field: 'liability_is_dui', type_id: null, folder: 'case', permissionType: permissionType}} apiDisabled={Boolean(savingByField.liability_is_dui)} showApiLoader={showApiLoader}/>
        <CheckboxCell conditionalCheck={true} label={'Hit & Run'} checked={caseData.liability_is_hit_run} direction={'reverse'} action={updatehandler} identifier={{type: 'case', field: 'liability_is_hit_run', type_id: null, folder: 'case', permissionType: permissionType}} apiDisabled={Boolean(savingByField.liability_is_hit_run)} showApiLoader={showApiLoader}/>
        <CheckboxCell label={'Rideshare'} checked={caseData.liability_is_ride_share} direction={'reverse'} action={updatehandler} identifier={{type: 'case', field: 'liability_is_ride_share', type_id: null, folder: 'case', permissionType: permissionType}} apiDisabled={Boolean(savingByField.liability_is_ride_share)} showApiLoader={showApiLoader}/>
        <CheckboxCell label={'Private Property'} checked={caseData.liability_is_private_property} direction={'reverse'} action={updatehandler} identifier={{type: 'case', field: 'liability_is_private_property', type_id: null, folder: 'case', permissionType: permissionType}} apiDisabled={Boolean(savingByField.liability_is_private_property)} showApiLoader={showApiLoader}/>
        <div className="flex-container gap-5">
            <CheckboxCell conditionalCheck={true} label={'Violent Crime'} checked={caseData.liability_is_violent_crime} direction={'reverse'} action={updatehandler} identifier={{type: 'case', field: 'liability_is_violent_crime', type_id: null, folder: 'case', permissionType: permissionType}} apiDisabled={Boolean(savingByField.liability_is_violent_crime)} showApiLoader={showApiLoader}/>
            <GlobalTooltip noMargin={true}>
                Checking this box will make visible the Crime Victims tab in the case.
            </GlobalTooltip>
        </div>
    </div>
}